// test425
(425 && 0);
